var map = {
	"./grid.tpl": 507,
	"./popups.tpl": 508,
	"./productBlock.tpl": 509,
	"./purchasesGrid.tpl": 510,
	"./storeScene.tpl": 511,
	"./storeVideos.tpl": 512
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;


//////////////////
// WEBPACK FOOTER
// ./components/store/templates /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader \.tpl$
// module id = 506
// module chunks = 4